import { Box, List, ListItemButton, ListItemIcon } from '@mui/material';
import './NavigationComponent.scss';

function NavigationComponent({ userNames, onItemClick, selectedNavItem }) {
  const badgeIcon = require('../../img/badge-icon.png');
  const shieldIcon = require('../../img/shield-icon.png');
  const avatarsIcon = require('../../img/avatars-icon.png');

  return (
    <List className='nav-content'>
    <ListItemButton disableRipple className={`nav-button ${selectedNavItem  === 'MyProfile' ? 'active-link' : ''}`} onClick={() => onItemClick('MyProfile')}>
        <ListItemIcon className='list-icon'>
          <img className='icon' src={badgeIcon} alt='My profile'/>
        </ListItemIcon>
        <Box className={`nav-text ${selectedNavItem  === 'MyProfile' ? 'active-link' : ''}`}>My profile</Box>
      </ListItemButton>

      <ListItemButton disableRipple className={`nav-button ${selectedNavItem  === 'LoginSecurity' ? 'active-link' : ''}`} onClick={() => onItemClick('LoginSecurity')}>
        <ListItemIcon className='list-icon'>
          <img className='icon' src={shieldIcon} alt='Login & security'/>
        </ListItemIcon>
        <Box className={`nav-text ${selectedNavItem  === 'LoginSecurity' ? 'active-link' : ''}`}>Login &amp; security</Box>
      </ListItemButton>
      { userNames.length > 0 && (
        <ListItemButton disableRipple className={`nav-button ${selectedNavItem  === 'MyUserNames' ? 'active-link' : ''}`} onClick={() => onItemClick('MyUserNames')}>
          <ListItemIcon className='list-icon'>
            <img className='icon' src={avatarsIcon} alt='My usernames'/>
          </ListItemIcon>
          <Box className={`nav-text ${selectedNavItem  === 'MyUserNames' ? 'active-link' : ''}`}>My usernames</Box>
        </ListItemButton>
      )}
    </List>
  );
}

export default NavigationComponent;
